<h2>Select a time</h2>

<div class="flex justify-content-center">
  <div class="flex flex-column gap-2">
    @for (time of times; track $index) {
    <p-button [styleClass]="selectedTime?.index === time.index ? 'selected' : 'select-btn'" (click)="onTimeClick(time)">{{time.formatedTimeAndRate}}</p-button>
    }
  </div>
</div>
<div class="flex justify-content-between mt-1 w-full">
  <p-button (click)="onBackClick()" label="BACK"></p-button>
  <p-button (click)="onNextClick()" [disabled]="!selectedTime" label="NEXT"></p-button>
</div>
@if (isLoading()) {
<div class="progress-spinner">
  <p-progressSpinner></p-progressSpinner>
</div>
}